import type { AccommodationHotelPolicyFormModel } from "@/components/features/items/edit/hotel-policy/default/model/type";

export const LOCAL_PAYMENT_AVAILABLE_LIMIT_DAYS_DEFAULT_VALUE: AccommodationHotelPolicyFormModel["ViewModel"]["localPaymentCancelFeeTransferLimitDays"] =
	{
		limitDays: {
			isEdited: true,
			value: 7,
		},
	};

export const LOCAL_PAYMENT_CANCEL_FEE_TRANSFER_INFO_DEFAULT_VALUE: AccommodationHotelPolicyFormModel["ViewModel"]["localPaymentCancelFeeTransferInfo"] =
	{
		bankAccountHolderName: {
			isEdited: true,
			value: "",
		},
		bankAccountNumber: {
			isEdited: true,
			value: "",
		},
		bankAccountType: {
			isEdited: true,
			value: "",
		},
		bankName: {
			isEdited: true,
			value: "",
		},
		branchName: {
			isEdited: true,
			value: "",
		},
	};
